import axios from "axios"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { deleteGuestCart, fetchUserCart, fetchProducts } from "../../store"
import { emailValidator, capitalizeFirstLetter } from "../../util"
import "../styles/CheckoutPage.css"

const CheckoutPage = () => {
  const cart = useSelector((state) => state.cart)
  const auth = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [street, setStreet] = useState("")
  const [city, setCity] = useState("")
  const [state, setState] = useState("")
  const [zip, setZip] = useState("")
  const [ccName, setCcName] = useState("")
  const [ccNumber, setCcNumber] = useState("")
  const [exp, setExp] = useState("")
  const [ccv, setCcv] = useState("")
  const [email, setEmail] = useState("")

  const [status, setStatus] = useState("pending")
  const [order, setOrder] = useState({ data: { createdAt: "" } })

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setLeadInfo({ ...leadInfo, [name]: value })
  }

  const submit = async (event) => {
    try {
      event.preventDefault()
      if (auth.id) {
        const newOrder = {
          firstName,
          lastName,
          street,
          city,
          state,
          zip,
          userId: auth.id,
          email,
        }
        const token = window.localStorage.getItem("token")
        const response = await axios.post(
          "/api/orders",
          { data: newOrder },
          {
            headers: {
              authorization: token,
            },
          }
        )
        setOrder(response)
        dispatch(fetchProducts())
        dispatch(fetchUserCart())
        setStatus("created")
      } else {
        const newOrder = {
          firstName,
          lastName,
          street,
          city,
          state,
          zip,
          email,
        }
        const response = await axios.post("/api/orders", {
          data: { newOrder, cart },
        })
        setOrder(response)
        dispatch(deleteGuestCart())
        dispatch(fetchProducts())
        setStatus("created")
      }
    } catch (error) {
      setStatus("error")
    }
  }

  const OrderCreated = ({ props }) => {
    console.log(props)
    return (
      <div className="order-created">
        <h1 className="created-success">Order Created</h1>
        <h2 className="created-success">
          Thank you {props.data.firstName} {props.data.lastName} for shopping
          with us.
        </h2>
        <h4>Order Placed at: {props.data.createdAt}</h4>
        <h4>Shipping to:</h4>
        <h4>{props.data.street}</h4>
        <h4>
          {props.data.city}, {props.data.state} {props.data.zip}
        </h4>
        <h4>Estimated Arrival: 2 Days</h4>
        <button
          className="return-to-account-btn"
          onClick={() => {
            navigate("/orders")
          }}
        >
          Return to Account
        </button>
      </div>
    )
  }

  const OrderFailed = (
    <div className="order-failed">
      <h1>Order Failed</h1>
      <button className="retry-button" onClick={() => setStatus("pending")}>
        Try Again
      </button>
    </div>
  )

  const CheckoutForm = (
    <div className="checkout-form-container">
      <div className="form-wrapper">
        <h1 className="form-header">Enter Details</h1>
        <form onSubmit={submit}>
          {/* Row for First Name and Last Name */}
          <div className="form-row">
            <div className="form-column half-width">
              <h3>First Name</h3>
              <input
                type="text"
                name="firstName"
                className={firstName !== "" ? "input-primary" : "input-warning"}
                value={firstName}
                onChange={(e) =>
                  setFirstName(capitalizeFirstLetter(e.target.value))
                }
              />
            </div>
            <div className="form-column half-width">
              <h3>Last Name</h3>
              <input
                type="text"
                name="lastName"
                className={lastName !== "" ? "input-primary" : "input-warning"}
                value={lastName}
                onChange={(e) =>
                  setLastName(capitalizeFirstLetter(e.target.value))
                }
              />
            </div>
          </div>

          <div className="form-column">
            <h3>Email</h3>
            <input
              type="text"
              className={
                emailValidator(email)
                  ? "input-bordered input-primary input bg-neutral m-2 w-full border-2 text-black"
                  : "input-bordered input-warning input bg-neutral m-2 w-full border-2 text-black"
              }
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="form-column">
            <h3>Street</h3>
            <input
              type="text"
              className={
                street !== ""
                  ? "input-bordered input-primary input bg-neutral m-2 w-full border-2 text-black"
                  : "input-bordered input-warning input bg-neutral m-2 w-full border-2 text-black"
              }
              value={street}
              onChange={(event) => setStreet(event.target.value)}
            />
          </div>

          {/* Row for City, State, and Zip */}
          <div className="form-row">
            <div className="form-column third-width">
              <h3>City</h3>
              <input
                type="text"
                className={city !== "" ? "input-primary" : "input-warning"}
                value={city}
                onChange={(event) => setCity(event.target.value)}
              />
            </div>
            <div className="form-column third-width">
              <h3>State</h3>
              <input
                type="text"
                className={state !== "" ? "input-primary" : "input-warning"}
                value={state}
                onChange={(event) => setState(event.target.value)}
              />
            </div>
            <div className="form-column third-width">
              <h3>Zip</h3>
              <input
                type="text"
                className={zip !== "" ? "input-primary" : "input-warning"}
                value={zip}
                onChange={(event) => setZip(event.target.value)}
              />
            </div>
          </div>

          <h3 className="full-width-margin">Name on Card</h3>
          <input
            type="text"
            className={
              ccName !== ""
                ? "input-bordered input-primary input bg-neutral m-2 w-full border-2 text-black"
                : "input-bordered input-warning input bg-neutral m-2 w-full border-2 text-black"
            }
            autoComplete="cc-name"
            value={ccName}
            onChange={(event) => setCcName(event.target.value)}
          />
          <h3 className="full-width-margin">CC Number</h3>
          <input
            type="text"
            className={
              ccNumber.length === 16
                ? "input-bordered input-primary input bg-neutral m-2 w-full border-2 text-black"
                : "input-bordered input-warning input bg-neutral m-2 w-full border-2 text-black"
            }
            autoComplete="cc-number"
            value={ccNumber}
            onChange={(event) => setCcNumber(event.target.value)}
          />

          {/* Row for Exp. and CVV */}
          <div className="form-row">
            <div className="form-column half-width">
              <h3>Exp.</h3>
              <input
                type="text"
                className={exp !== "" ? "input-primary" : "input-warning"}
                value={exp}
                onChange={(event) => setExp(event.target.value)}
              />
            </div>
            <div className="form-column half-width">
              <h3>CVV</h3>
              <input
                type="text"
                className={ccv !== "" ? "input-primary" : "input-warning"}
                value={ccv}
                onChange={(event) => setCcv(event.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <button
              className="btn-primary"
              disabled={
                firstName === "" ||
                lastName === "" ||
                street === "" ||
                ccName === "" ||
                !emailValidator(email) ||
                city === "" ||
                (zip.length !== 5 && zip.length !== 10) ||
                ccNumber.length !== 16 ||
                ccv.length !== 3 ||
                exp === "" ||
                state === ""
              }
            >
              Create Order
            </button>
          </div>
        </form>
      </div>
    </div>
  )

  if (status === "pending") {
    return CheckoutForm
  } else if (status === "created") {
    return <OrderCreated props={order} />
  } else {
    return OrderFailed
  }
}

export default CheckoutPage
